import { FC, PropsWithChildren } from 'react'
import { useNavigate } from 'react-router-dom'

import Sidebar from '@parts/Sidebar/Sidebar'
import { useAuthStore } from 'shared/store'

import { logout } from '@api/auth.requests'
import { engDepartments } from 'shared/types'
import { LogoIcon, LogoutIcon } from '../../assets/icons'

import styles from './PageHeader.module.scss'

const logoutIconElement = <LogoutIcon className={styles.logoutIcon} onClick={logout} />

const PageHeader: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate()
  const { user } = useAuthStore((state) => state)

  const logoOnClick = () => navigate(`/`)

  return (
    <div className={styles.pageHeader}>
      <Sidebar modificator={styles.logoBlock}>
        <div className={styles.logoTitle} onClick={logoOnClick}>
          <LogoIcon className={styles.logoIcon} /> Сценарист
        </div>
      </Sidebar>
      <div className={styles.content}>{children}</div>
      <div className={styles.username}>
        {user && (
          <>
            <p className={styles.label}>{engDepartments[user.department]}:</p>
            <p className={styles.name}>
              {user.firstName} {user.lastName}
            </p>
          </>
        )}
        <p className={styles.icon}>{logoutIconElement}</p>
      </div>
    </div>
  )
}

export default PageHeader
